export default "__VITE_ASSET__BhiH6l6g__"